import React, { useEffect, useState } from 'react';
import { paises } from '../../assets/paises';
import { Modal, Button, Form, Input, Radio } from 'antd';
import { useHistory } from 'react-router-dom';

import 'antd/dist/antd.css';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao'
import { connect } from 'react-redux';
import { ColumnsType } from 'antd/lib/table';

import { Table, Tag, Space } from 'antd';
import { bindActionCreators } from 'redux';
import moment from 'moment';

interface ModalAgendadosProps {
    modalStatus?: any,
    permissao?: any,
    setAgendadosModal?: any
}

const ModalAgendados: React.FC<ModalAgendadosProps> = (prop) => {
    let history = useHistory();
    let visible = prop.modalStatus[0].visibleAgendados
    const [dataSelecionada, setDataSelectionada] = useState<any>(null);
    const [perfilLogado, setPerfilLogado] = useState<number>()
    const { Column, ColumnGroup } = Table;

    const handleCancel = () => {
        prop.setAgendadosModal(false);
    };

    useEffect(() => {
        setDataSelectionada(moment(new Date(prop.modalStatus[0].dataSelecionada?.getUTCFullYear(), prop.modalStatus[0].dataSelecionada?.getMonth(), prop.modalStatus[0].dataSelecionada?.getUTCDate())).format("DD/MM/YYYY"))
        setPerfilLogado(parseInt(sessionStorage.getItem("grupoID") || ""))
    }, [prop.modalStatus[0]])

    const realizarCadastro = (agendamentoID: any, dadosCadastraisID: any) => {
        history.push(`dados-cadastrais/cadastro/${dadosCadastraisID}/agendamento/${agendamentoID}/tabela/1`);
        prop.setAgendadosModal(false);
    }

    const ehRecepcao = () => {
        if (perfilLogado == 1446 || perfilLogado == 1447 || perfilLogado == 1448) {
            return true
        } else {
            return false
        }
    }

    const dataSource = (prop.modalStatus[0].data || []).filter((item: any) => item !== undefined && item !== null);


    const formatarHora = ((values: any) => {
        const data = new Date(values)
        return moment(data).format("HH:mm")
    })

    return (
        <Modal
            width="80%"
            visible={visible}
            title={`Agendamentos do Dia: ${dataSelecionada}`}
            onCancel={handleCancel}
            footer={null}
        >
            <Table rowKey={"agendamentoID"} bordered={true} dataSource={dataSource}>
                <Column render={(values, record, index) => { return formatarHora(values) }} width="10%" title="Hora" dataIndex="dataHoraInicio" />
                <Column width="25%" title="Nome    -    País" dataIndex="nome" />
                <Column width="20%" title="Telefone" dataIndex="telefone" />
                <Column width="30%" title="Motivo" dataIndex="motivo" />
                <Column width="15%" title="Situação" dataIndex="situacao" />
                {ehRecepcao() ? null: <Column render={(record) => {
                    return <Button className="button-alterar" type="dashed" htmlType="button" onClick={() => { realizarCadastro(record.agendamentoID, record.dadosCadastraisID) }}>
                        Realizar Atendimento
                    </Button>
                }} width="10%" title="Ações" fixed="right" key="action" />}
                
            </Table>

        </Modal >
    );
}


const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    data: state.data,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}
export default connect(mapStateToProps, mapDispatcToProps)(ModalAgendados);